import React from 'react';
import { FadeIn, Button } from './ui';
import { trackAddToCart } from '../lib/pixel';
export const Offer = () => {
  return <section id="offer" className="py-24 px-6 relative scroll-mt-8" data-id="element-99">
      <div className="max-w-2xl mx-auto text-center" data-id="element-100">
        <FadeIn data-id="element-101">
          <h2 className="text-4xl md:text-5xl mb-8 text-balance" data-id="element-102">
            Reclaim your nights.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-103">
          <p className="text-lg text-parchment-muted font-light leading-relaxed mb-10 max-w-lg mx-auto" data-id="element-104">
            Less than the cost of a large pizza. No subscriptions, no expensive
            supplements, no "sleep retreats." Just a manual override for your
            brain.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-105">
          <div className="mb-10" data-id="element-106">
            <span className="font-serif text-5xl text-amber" data-id="element-107">$6.99</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-108">
          <div className="flex flex-col items-center gap-4" data-id="element-109">
            <Button href="https://mybloommind.com/cart/55687466057801:1" onClick={() => trackAddToCart({
            value: 6.99,
            currency: 'USD',
            content_name: 'The 3AM Mind-Quiet Script',
            content_ids: ['55687466057801']
          })} className="text-lg px-10 py-5 w-full md:w-auto" data-id="element-110">
              Get The 3AM Mind-Quiet Script Now
            </Button>
            <p className="text-sm text-parchment-dark font-light tracking-wide uppercase" data-id="element-111">
              Instant PDF Download • Start tonight
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};